import React from 'react'
import PropTypes from 'prop-types'
import Translations from '../../../../../requests/apa/Translator';
import PlayerStreamingUtils from '../../../../../utils/PlayerStreamingUtils'
import asyncPinObserver from '../../../../../AAF/Pin/AsyncPinObserver'
import { PurchaseButtonInfov585 } from '../../../../../requests/loader'
import Assets from '../../../../../requests/apa/Asset';
import './_MatchDetailUpsellPanel.scss'
import { setPendingMatchModal } from '../../pendingMatchModal.js'
import logger from 'src/utils/logger/logger';

// Constantes del carrusel: cada pill mide 14.333rem + 0.7rem margin × 2
var PILL_WIDTH_REM        = 14.333 + 1.4
var PILLS_WRAP_WIDTH      = 45.8  // Ancho visible del viewport

/**
 * MatchDetailUpsellPanel
 *
 * Columna derecha del layout EN VIVO cuando el usuario NO tiene
 * derechos de reproducción (Figma B_31 — node 2654:65752 "Largepaquetes").
 * Muestra:
 *  - Título "Partido disponible con" + logos de canales (máx. 3 pills)
 *  - Texto "Contrata ClaroTV {packageName}"
 *  - Subtítulo "Para disfrutar de este partido y muchos más"
 *  - Botón "Contratar"
 *
 * Props:
 *  - channels        {array}   [ { logoUrl, name } ] — máx. 3 — canales para las pills
 *  - packageName     {string}  Nombre del paquete a promocionar
 *  - onChannelClick  {func}    Callback al presionar una pill de canal (recibe el canal)
 *  - onContratarClick {func}   Callback al presionar "Contratar"
 */
class MatchDetailUpsellPanel extends React.Component {
  constructor (props) {
    super(props)
    this.state = { focusedChannelIndex: 0, lastFocusedGroupId: null, pbi: null, pbiLoading: true }
    this.handleChannelFocus = this.handleChannelFocus.bind(this)
  }

  componentDidMount () {
    var channels = (this.props.channels || []).filter(function (ch) {
     return !ch.media || ch.media === ''
    })
    var firstChannel = channels[0]
    if (firstChannel && firstChannel.groupId) {
      var groupId = firstChannel.groupId
      PurchaseButtonInfov585({ groupId })
        .then(function (pbi) {
          this.setState({ pbi: pbi, pbiLoading: false })
        }.bind(this))
        .catch(function (err) {
          logger.debug('[MatchDetailUpsellPanel] PurchaseButtonInfov585 catch err', err)
          this.setState({ pbiLoading: false })
        }.bind(this))
    } else {
      this.setState({ pbiLoading: false })
    }
  }

  handleChannelFocus (index, groupId) {
    this.setState({ focusedChannelIndex: index, lastFocusedGroupId: groupId || null })
  }

  // Desplaza el track cuando el pill focalizado sale del viewport por la derecha.
  // Mantiene visible el máximo de pills posible sin centrar.
  getTrackOffset (focusedIndex, total) {
    var pillStart = focusedIndex * PILL_WIDTH_REM
    var pillEnd   = pillStart + PILL_WIDTH_REM
    var totalWidth  = total * PILL_WIDTH_REM

    var raw = 0

    // Si el pill está fuera del viewport por la derecha, desplazar
    if (pillEnd > PILLS_WRAP_WIDTH) {
      raw = pillEnd - PILLS_WRAP_WIDTH
    }

    // Limitar para no pasarse del final total
    raw = Math.min(Math.max(0, totalWidth - PILLS_WRAP_WIDTH), raw)

    return -raw
  }

  render () {
    var pbiLoading = this.state.pbiLoading
    var pbi = this.state.pbi
    var pbiButtons = pbi  && pbi.listButtons && Array.isArray(pbi.listButtons.button)
      ? pbi.listButtons.button
      : []
    var hasMultipleButtons = pbiButtons.length > 1

    var channels = (this.props.channels || []).filter(function (ch) {
      return !ch.media || ch.media === ''
    })
    var packageName      = this.props.packageName || ''
    var onContratarClick = this.props.onContratarClick
    var onChannelClick   = this.props.onChannelClick
    var focusedIndex        = this.state.focusedChannelIndex
    var lastFocusedGroupId  = this.state.lastFocusedGroupId !== null
      ? this.state.lastFocusedGroupId
      : (channels[0] ? channels[0].groupId : null)
    var total           = channels.length
    var trackOffset     = total > 0 ? this.getTrackOffset(focusedIndex, total) : 0

    return (
      <div className='match-detail-upsell-panel'>
        {!pbiLoading && (
        <div className='match-detail-upsell-panel__content'>
        {/* ── Sección superior: "Partido disponible con" + pills ── */}
        <div className='match-detail-upsell-panel__top'>
          <p className='match-detail-upsell-panel__available-title'>
            {Translations.get('eventodeportivo_partidos_formasdever_texto_titulo')}
          </p>

          <div className='match-detail-upsell-panel__channel-list'>
            <div
              className='match-detail-upsell-panel__channel-track'
              style={{ transform: 'translateX(' + trackOffset + 'rem)' }}
            >
              {channels.map(function (channel, index) {
                return (
                  <a
                    key={index}
                    role='button'
                    tabIndex='0'
                    className={
                      'focusable match-detail-upsell-panel__channel-pill' +
                      (focusedIndex === index ? ' match-detail-upsell-panel__channel-pill--focused' : '')
                    }
                    onFocus={function () { this.handleChannelFocus(index, channel.groupId) }.bind(this)}
                    onClick={typeof onChannelClick === 'function' ? function () { onChannelClick(channel) } : undefined}
                    onKeyDown={typeof onChannelClick === 'function' ? function (e) {
                      var k = e.keyCode || e.which
                      if (k === 13 || k === 32) { e.preventDefault(); onChannelClick(channel) }
                    } : undefined}
                    data-sn-left={index > 0 ? '#mdvp-upsell-channel-' + (index - 1) : undefined}
                    data-sn-right={index < total - 1 ? '#mdvp-upsell-channel-' + (index + 1) : undefined}
                    data-sn-down='.match-detail-upsell-panel__contratar-btn'
                    id={'mdvp-upsell-channel-' + index}
                  >
                    <div className='match-detail-upsell-panel__channel-inner'>
                      {channel.image
                        ? <img
                            src={channel.image}
                            alt={''}
                            className='match-detail-upsell-panel__channel-logo'
                          />
                        : null
                      }
                    </div>
                  </a>
                )
              }, this)}
            </div>
          </div>
        </div>

        {/* ── Sección inferior: Contrata + botón ── */}
        <div className={`match-detail-upsell-panel__bottom${hasMultipleButtons ? ' match-detail-upsell-panel__bottom--multiple-buttons' : ''}`}>
          {hasMultipleButtons ? (
            <p className='match-detail-upsell-panel__subtitle'>
              Contrata un paquete y accede ahora
            </p>
          ) : (
            <div>
              <div className='match-detail-upsell-panel__cta-row'>
                <span className='match-detail-upsell-panel__cta-label'>{Translations.get('eventodeportivo_partidos_formasdever_texto_parrafo_parte1')}</span>
                <img className='match-detail-upsell-panel__claro-logo' src={Assets.get('eventodeportivo_partidos_formasdever_imagen_clarovideo')} alt='Claro Video' />
                <span className='match-detail-upsell-panel__cta-label'>{Translations.get('eventodeportivo_partidos_formasdever_texto_parrafo_parte2')}</span>
                {packageName
                  ? <span className='match-detail-upsell-panel__package-name'>{packageName}</span>
                  : null
                }
              </div>
              <p className='match-detail-upsell-panel__subtitle'>
                {Translations.get('eventodeportivo_partidos_formasdever_texto_parrafo_parte3')}
              </p>
            </div>
          )}

          <button
            id='mdvp-contratar-btn'
            type='button'
            className='focusable match-detail-upsell-panel__contratar-btn'
            onKeyDown={function (e) {
              var k = e.keyCode || e.which
              if (k === 13 || k === 32) { e.preventDefault(); e.currentTarget.click() }
            }}
            onClick={() => {
              logger.debug('[UpsellPanel] lastFocusedGroupId:', lastFocusedGroupId)
              if (lastFocusedGroupId) {
                var playerStreamingUtils = new PlayerStreamingUtils()
                var canPlayChannel = playerStreamingUtils.canPlayChannel(lastFocusedGroupId)
                //if (canPlayChannel) {
                  asyncPinObserver.fire('awaitpbiInfo')

                 setPendingMatchModal({ matchData: this.props.matchData, callback: this.props.callback })
                  playerStreamingUtils.checkSusc(null, lastFocusedGroupId, function () {}, {playFromMatchDetail: true}).then(function () {
                    asyncPinObserver.fire('pbiInfocomplete')
                  })
                //}
              }
              if (typeof onContratarClick === 'function') onContratarClick(lastFocusedGroupId)
            }}
            data-sn-up={channels.length > 0 ? '.match-detail-upsell-panel__channel-pill' : undefined}
          >
            {hasMultipleButtons
              ? 'Ver paquetes'
              : Translations.get('eventodeportivo_partidos_formasdever_boton_texto_contratar')
            }
          </button>
        </div>
        </div>
        )}
      </div>
    )
  }
}

MatchDetailUpsellPanel.propTypes = {
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      name: PropTypes.string
    })
  ),
  packageName: PropTypes.string,
  onChannelClick: PropTypes.func,
  onContratarClick: PropTypes.func,
  matchData: PropTypes.object,
  callback: PropTypes.func
}

MatchDetailUpsellPanel.defaultProps = {
  channels: [],
  packageName: '',
  onChannelClick: null,
  onContratarClick: null,
  matchData: null,
  callback: null
}

export default MatchDetailUpsellPanel



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailUpsellPanel/MatchDetailUpsellPanel.jsx